import React from 'react'
import { TrustpilotWidgetBase } from '../Base';

export const TrustpilotWidgetCarousel = () => {
  return <TrustpilotWidgetBase
    locale="en-GB"
    templateId="53aa8912dec7e10d38f59f36"
    stars='4,5'
    businessUnitId="5e99bfb13e39470001f6ee60"
    height="150px"
    width="100%"
    theme="light"
    fontFamily='Libre Baskerville'
    style={{
      maxWidth: 'none'
    }}
  />

}
